import { render, staticRenderFns } from "./DeleteOrder.vue?vue&type=template&id=37d380b6&scoped=true&"
import script from "./DeleteOrder.vue?vue&type=script&lang=js&"
export * from "./DeleteOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d380b6",
  null
  
)

export default component.exports